import React, { Fragment } from 'react';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { getBuildAndPriceLink } from 'client/site-modules/shared/utils/build-and-price-link-constructor';
import { SORT_BY, INVENTORY_TYPE } from 'site-modules/shared/constants/allowed-seo-srp-request-params';
import { SubCtaLink } from 'site-modules/shared/components/core-page/sub-cta-link/sub-cta-link';
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { PAGE_URL } from 'site-modules/shared/constants/page-urls';
import { BEST_DEAL_DESC } from 'site-modules/shared/constants/sort-types';
import { getInventoryTypesForPublicationStates } from 'site-modules/shared/utils/inventory-utils/get-inventory-types-for-publication-state';

export function getSubCTALink(link, text) {
  return (
    <SubCtaLink rel="nofollow" to={link}>
      {text}
    </SubCtaLink>
  );
}

export function NoIncentivesExperience({ makeModelSubmodelYear = null }) {
  if (!makeModelSubmodelYear) {
    return null;
  }

  const makeName = makeModelSubmodelYear.make.name;
  const makeSlug = makeModelSubmodelYear.make.slug;
  const modelSlug = makeModelSubmodelYear.model.slug;
  const year = makeModelSubmodelYear.year;
  const pubStates = makeModelSubmodelYear.pubStates;
  const inventoryTypesForPubStates = getInventoryTypesForPublicationStates(Object.keys(pubStates));
  const inventoryTypes = inventoryTypesForPubStates.map(item => item.toLowerCase());

  const srpParams = {
    make: makeSlug,
    model: modelSlug,
    year: Number(year),
  };

  return (
    <Fragment>
      <p className="mb-2">
        {`Currently there are no incentives or rebates being offered by ${makeName} in your area.`}
      </p>
      {getSubCTALink(getBuildAndPriceLink({ make: makeSlug, model: modelSlug, year }), 'Build & Price')}
      {getSubCTALink(
        srpLinkBuilder({
          ...srpParams,
          [INVENTORY_TYPE]: inventoryTypes,
          [SORT_BY]: BEST_DEAL_DESC,
        }),
        'See Best Deals'
      )}
      {getSubCTALink(PAGE_URL.CAR_INCENTIVES, 'See other makes')}
    </Fragment>
  );
}

NoIncentivesExperience.propTypes = {
  makeModelSubmodelYear: VehicleEntities.MakeModelSubmodelYear,
};
